export const DISCOUNT_TIERS = [
  // MUST be ordered from lowest to highest
  {
    numberOfItems: 2,
    discountPercentage: 10
  },
  {
    numberOfItems: 3,
    discountPercentage: 15
  }
];

export const i = 0;
